module.exports = __webpack_public_path__ + "public/SiteIcons/deleteIcon.svg?e255a206";